import script from "./BaseErrors.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseErrors.vue?vue&type=script&setup=true&lang=ts"

import "./BaseErrors.vue?vue&type=style&index=0&id=cdc367f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdc367f8"]])

export default __exports__